var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./VueAvatarEditor.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-e8ca362c\",\"hasScoped\":false}!../../../vue-loader/lib/selector?type=template&index=0!./VueAvatarEditor.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-avatar-editor-improved/src/components/VueAvatarEditor.vue
// module id = 947
// module chunks = 2 4 5